<div class="modal-header">
  <label class="col-form-label" style="font-weight: bold">Modificar Proveedor "{{ objProveedor.codcli }} -
    {{ objProveedor.razonc }}"</label>
  <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"
    tabindex="13">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">
      <div>
        <button [disabled]="encontro" tabindex="22" type="button" class="btn btn-rounded btn-info m-b-15"
          (click)="modificarCliente()">
          <i class="fa fa-save"></i> Guardar
        </button>
        <button tabindex="22" type="button" class="btn btn-rounded btn-danger m-b-15" (click)="eliminarProveedor()"
          [hidden]="objProveedor.codcli == null || objProveedor.dident == null">
          <i class="fa fa-trash"></i> Eliminar
        </button>
        <button (keydown.tab)="onNexFocus('Modificar')" tabindex="23" type="button"
          class="btn btn-rounded btn-warning m-b-15" (click)="cancelarInsercion()">
          <i class="fa fa-times-circle"></i> Cancelar
        </button>
      </div>

      <div class="card">
        <div class="card-body">
          <div [hidden]="vista !== 1">
            <ngb-tabset>
              <ngb-tab title="Proveedor">
                <ng-template ngbTabContent>
                  <div class="card-body">
                    <button class="btn btn-outline-dark" routerLinkActive="active" (click)="importarDatosSunat()"
                      id="btnImportar">
                      <img src="./assets/img/Sunat.ico" style="width: 16px; height: 16px; margin-left: -0.5rem" />
                      Importa de SUNAT
                    </button>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Proveedor:
                          </label>
                          <div class="col-sm-2">
                            <input type="text" class="focus-input input_border form-control tsiInput mr-2"
                              name="desInterlocutor" [(ngModel)]="objProveedor.codcli" [disabled]="disabledInterlocutor"
                              tabindex="5" (keydown.enter)="
                                onKeyEnterCodInterlocutor($event)
                              " />
                          </div>
                          <div class="input-group col-md-7" style="margin-left:-2px">
                            <input type="text" class="focus-input input_border form-control  tsiInput col-md-10"
                              name="codInterlocutor" [(ngModel)]="objProveedor.razonc" [disabled]="disabledInterlocutor"
                              tabindex="6" #interlocutor (keydown.enter)="onKeyEnterInterlocutor($event)" />
                            <div class="input-group-append " style="width:40px">
                              <button *ngIf="buscarLimpiarBoton == 'buscar'" class="btn btn-primary btn-sm boton "
                                (click)="openModalInterlocutor()" type="button" tabindex="7">
                                <i class="fa fa-search"></i>
                              </button>
                              <button *ngIf="buscarLimpiarBoton == 'borrar'" class="btn btn-primary btn-sm boton "
                                (click)="borrarDatosInterlocutor()" type="button" tabindex="7">
                                <i class="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Tipo de persona:
                          </label>
                          <div class="col-sm-2 ">
                            <select [disabled]="encontro"
                              class="focus-input input_border tsiSelect select_border col-sm-12" (change)="
                                onSelectTipoPersonaIns($event.target.value)
                              " id="tipopersonatab" name="tipopersonatab" #tipopersonatab
                              [(ngModel)]="objProveedor.codtpe" tabindex="1">
                              <option *ngFor="let lst of tipopersona" value="{{ lst.codtpe }}">
                                {{ lst.destpe }}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Tipo de identidad:
                          </label>
                          <div class="col-sm-3 ">
                            <select [disabled]="encontro"
                              class="focus-input input_border  tsiSelect select_border col-sm-12 " id="tident" (change)="
                                onSelectTipoIdentidadIns($event.target.value)
                              " name="tident" [(ngModel)]="objProveedor.tident" tabindex="4">
                              <option *ngFor="let tipdoci of identidades" value="{{ tipdoci.tident }}">
                                {{ tipdoci.descri }}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2" style="margin-left: -17px">Doc.
                            de identidad:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="encontro" type="text"
                              class="focus-input input_border form-control tsiInput " #dident
                              (blur)="onBlurDocIdentidad()"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              [(ngModel)]="objProveedor.dident" (keyup)="oneKeyupIdentidad($event)" name="dident"
                              [maxlength]="tamanoidentidad" tabindex="5" />
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:
                          </label>
                          <div class="col-sm-5">
                            <input [disabled]="disable_codigo" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.codcli"
                              name="codcli" maxlength="20" tabindex="6" disabled />
                          </div>
                        </div>

                        <div *ngIf="tident == '06'">
                          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Apellidos y nombres:
                            </label>
                            <div class="col-sm-8 ">
                              <input [disabled]="encontro" type="text"
                                class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.razonc"
                                (keyup)="onKeyUpNombresCompletos($event)" name="razonc" maxlength="80" tabindex="7" />
                            </div>
                            <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                          </div>
                        </div>
                        <div *ngIf="tident != '06'">
                          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Razón social:
                            </label>
                            <div class="col-sm-8">
                              <input [disabled]="encontro" type="text"
                                class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.razonc"
                                name="razonc" maxlength="80" tabindex="7" />
                            </div>
                            <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Dirección 1:
                          </label>
                          <div class="col-sm-8">
                            <input [disabled]="encontro" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.direc1"
                              name="direc1" maxlength="100" tabindex="8" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Dirección 2:
                          </label>
                          <div class="col-sm-8">
                            <input [disabled]="encontro" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.direc2"
                              name="direc2" maxlength="100" tabindex="9" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Apellido paterno:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="encontro" type="text"
                              class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.apellidopaterno" name="apellidopaterno" maxlength="15"
                              tabindex="10" />
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Correo electrónico:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="encontro" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.email"
                              name="email" maxlength="50" tabindex="11" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Apellido materno:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="encontro" type="text"
                              class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.apeliidomaterno" name="apeliidomaterno" maxlength="15"
                              tabindex="12" />
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Teléfono:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="encontro" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.telefono"
                              name="telefono" maxlength="30" tabindex="13" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Nombres:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="encontro" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.nombres"
                              name="nombres" maxlength="30" tabindex="14" />
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Celular:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="encontro" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.fax"
                              name="fax" maxlength="30" tabindex="15" />
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">DNI:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="encontro" [disabled]="identidad" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.nrodni"
                              name="nrodni" maxlength="8" tabindex="16"
                              onkeypress="return event.charCode >= 8 && event.charCode <= 57" />
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Sexo:
                          </label>
                          <div class="col-sm-3">
                            <select [disabled]="encontro" tabindex="17"
                              class="focus-input input_border tsiSelect select_border col-sm-12" id="sexo" name="sexo"
                              [(ngModel)]="objProveedor.sexo">
                              <option value="M">Masculino</option>
                              <option value="F">Femenino</option>
                            </select>
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2 ">Condición de pago:</label>
                          <div class="col-sm-3">
                            <select [disabled]="encontro"
                              class="focus-input input_border tsiSelect select_border col-sm-12"
                              id="objProveedor.codpag" name="objProveedor.codpag" [(ngModel)]="objProveedor.codpag"
                              tabindex="19">
                              <option *ngFor="let tit of condicionespago" value="{{ tit.codpag }}">
                                {{ tit.despag }}
                              </option>
                            </select>
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Retenciones:
                          </label>
                          <div class="col-sm-3">
                            <select [disabled]="encontro"
                              class="focus-input input_border  tsiSelect select_border col-sm-12"
                              id="objProveedor.regret" name="objProveedor.regret" [(ngModel)]="objProveedor.regret"
                              tabindex="20">
                              <option *ngFor="let lst of clienteRegimenes" value="{{ lst.codigo }}">
                                {{ lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Comentario:
                          </label>
                          <div class="col-sm-8">
                            <input class="focus-input input_border tsiInput select_border form-control" id="repres"
                              name="repres" [(ngModel)]="objProveedor.repres" type="text" rows="6" maxlength="40"
                              tabindex="21" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <div class="form-group row mb-1 col-lg-12 justify-content-center">
                      <label for="fname2" class="text-left control-label col-md-3">Fecha creación:
                        {{ objProveedor.fcreac | date : "dd/MM/yyyy" }}
                      </label>

                      <!-- <input  type="date" [(ngModel)]="objCliente.factua" disabled
                            class="focus-input input_border form-control tsiInput col-sm-1"
                           > -->

                      <label for="fname2" class="text-left control-label col-md-3">Usuario: {{ objProveedor.ucreac }}
                      </label>

                      <!--  <input  type="text" [(ngModel)]="objCliente.ucreac" disabled
                            class="focus-input input_border form-control  tsiInput col-sm-2"> -->

                      <label for="fname2" class="text-left control-label col-md-3">Fecha Actualización:
                        {{ objProveedor.factua | date : "dd/MM/yyyy" }}
                      </label>

                      <!--  <input  type="date"  [(ngModel)]="objCliente.fcreac" disabled
                            class="focus-input input_border form-control  tsiInput col-sm-1"> -->

                      <label for="fname2" class="text-left control-label col-md-3">Usuario: {{ objProveedor.uactua }}
                      </label>
                      <!-- <input  type="text" [(ngModel)]="objCliente.uactua" disabled
                            class="focus-input input_border form-control  tsiInput col-sm-2"> -->
                    </div>
                  </div>
                </ng-template>
              </ngb-tab>
              <ngb-tab *ngIf="mostrar">
                <ng-template ngbTabTitle><b>Clases</b></ng-template>
                <ng-template ngbTabContent>

                  <button type="button" class="btn btn-rounded btn-success" (click)="NuevoModal(content1)"
                    style="margin-top: 20px">
                    <i class="fa fa-plus"></i> Nuevo
                  </button>

                  <button [disabled]="Ubigeobloc" type="button" class="btn btn-rounded btn-success "
                    style="margin-top: 20px" (click)="addUbigeo()">
                    <i class="fa fa-plus"></i> Ubigeo
                  </button>

                  <div class="table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover" style="margin-top: 30px">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Clase</th>
                          <th>Descripción</th>
                          <th>Código</th>
                          <th>Descripción</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of clases">
                          <td scope="row" style="
                              display: table-cell;
                              text-align: center;
                              padding-bottom: 0px;
                            ">
                            <div class="btn-group btn-group-xs" role="group" style="margin: 0px; padding: 0px">
                              <button type="button" class="btn btn-sm" style="border: none; outline: none;"
                                (click)="ModalModificarClase(content2, item)">
                                <span class="fas fa-pencil-alt" aria-hidden="true"></span>
                              </button>
                              <button type="button" class="btn btn-sm " style="border: none; outline: none;"
                                (click)="EliminarClase(item)">
                                <span class="fas fa-trash-alt" aria-hidden="true"></span>
                              </button>
                            </div>
                          </td>
                          <td scope="row">{{ item.clase }}</td>
                          <td style="white-space: nowrap">
                            {{ item.desclase }}
                          </td>
                          <td scope="row">{{ item.codigo }}</td>
                          <td style="white-space: nowrap">
                            {{ item.descodigo }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-template>
              </ngb-tab>

              <ngb-tab *ngIf="mostrar">
                <ng-template ngbTabTitle><b>Contactos</b></ng-template>
                <ng-template ngbTabContent>
                  <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="_mNuevoContacto()"
                    style="margin-top: 20px">
                    <i class="fa fa-plus"></i> Nuevo
                  </button>

                  <div class="table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover" style="margin-top: 15px">
                      <thead>
                        <tr>
                          <th></th>
                          <th>ID</th>
                          <th>Contacto</th>
                          <th>Cargo</th>
                          <th>Email</th>
                          <th>Teléfono</th>
                          <th class="text-center">Activo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of contactos">
                          <td scope="row" style="
                              display: table-cell;
                              text-align: center;
                              padding-bottom: 0px;
                            ">
                            <div class="btn-group btn-group-xs" role="group" style="margin: 0px; padding: 0px">
                              <button type="button" class="btn btn-sm" style="border: none; outline: none;"
                                (click)="_mEditarContacto(item)">
                                <span class="fas fa-pencil-alt" aria-hidden="true"></span>
                              </button>
                              <button type="button" class="btn btn-sm" style="border: none; outline: none;"
                                (click)="EliminarContacto(item)">
                                <span class="fas fa-trash-alt" aria-hidden="true"></span>
                              </button>
                            </div>
                          </td>
                          <td scope="row">{{ item.codcont }}</td>
                          <td style="white-space: nowrap">
                            {{ item.nomcont }}
                          </td>
                          <td style="white-space: nowrap">{{ item.cargo }}</td>
                          <td style="white-space: nowrap">{{ item.correo }}</td>
                          <td style="white-space: nowrap">
                            {{ item.telefono }}
                          </td>
                          <td>
                            <div style="text-align: center;" *ngIf="item.activo">
                              <i class="fas fa-check fa-lg" style="color: green;"></i>
                            </div>
                            <div style="text-align: center;" *ngIf="!item.activo">
                              <i class="fas fa-times fa-lg" style="color: red;"></i>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-template>
              </ngb-tab>
              <!--
              <ngb-tab *ngIf=mostrar>
              <ng-template ngbTabTitle><b>Especificaciones</b></ng-template>
              <ng-template ngbTabContent>
                <hr>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col-md-3">
                        <button type="button" class="btn btn-rounded btn-success m-b-15"
                          (click)="NuevoModal(content7)"><i class="fa fa-plus"></i> Nuevo </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th>V. Decimal</th>
                        <th>V. Cadena</th>
                        <th>V. Caracter</th>
                        <th>V. Fecha</th>
                        <th>V. Entero</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of especificaciones">
                        <td scope="row" style="display: table-cell; text-align: center; padding-bottom: 0px;">
                          <div class="btn-group btn-group-xs" role="group" style="margin: 0px;padding: 0px;"><button
                              type="button" class="btn btn-sm"
                              (click)="AbrirModificarEspecificacion(content8 , item)"><span class="fas fa-pencil-alt"
                                aria-hidden="true"></span></button>
                            <button type="button" class="btn btn-sm " (click)="EliminarEspecificacion(item)"><span
                                class="fas fa-trash-alt" aria-hidden="true"></span></button>
                          </div>
                        </td>
                        <td scope="row">{{ item.codesp }}</td>
                        <td style="white-space: nowrap;">{{ item.descri }}</td>
                        <td style="white-space: nowrap;">{{ item.vreal }}</td>
                        <td style="white-space: nowrap;">{{ item.vstrg }}</td>
                        <td style="white-space: nowrap;">{{ item.vchar }}</td>
                        <td style="white-space: nowrap;">{{ item.vdate }}</td>
                        <td style="white-space: nowrap;">{{ item.ventero }}</td>

                        <td>
                          <div style="text-align: center;" *ngIf="item.activo == true"> <i class="fas fa-check fa-lg"
                              style="color: green;"></i></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </ng-template>
            </ngb-tab> -->
              <ngb-tab *ngIf="mostrar">
                <ng-template ngbTabTitle><b>Direcciones de envío</b></ng-template>
                <ng-template ngbTabContent>

                  <button type="button" class="btn btn-rounded btn-success" style="margin-top: 20px"
                    (click)="NuevoModal(content9)">
                    <i class="fa fa-plus"></i> Nuevo
                  </button>
                  <!-- <button type="button" class="btn btn-rounded btn-success m-b-15 m-b-15" (click)="open1(content3)"><i
                                              class="fa fa-plus"></i> Ubigeo </button> -->

                  <div class="table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover" style="margin-top: 15px"
                      style="margin-top: 30px">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Código</th>
                          <th>Almacén</th>
                          <th>Dirección 1</th>
                          <th>Dirección 2</th>
                          <th>Activo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of direcciones">
                          <td scope="row" style="
                              display: table-cell;
                              text-align: center;
                              padding-bottom: 0px;
                            ">
                            <div class="btn-group btn-group-xs" role="group" style="margin: 0px; padding: 0px">
                              <button type="button" class="btn btn-sm" style="border: none; outline: none;" (click)="
                                  AbrirModificarDirecciones(content10, item)
                                ">
                                <span class="fas fa-pencil-alt" aria-hidden="true"></span>
                              </button>
                              <button type="button" class="btn btn-sm" style="border: none; outline: none;"
                                (click)="EliminarDireccion(item)">
                                <span class="fas fa-trash-alt" aria-hidden="true"></span>
                              </button>
                            </div>
                          </td>
                          <td scope="row">{{ item.codenv }}</td>
                          <td style="white-space: nowrap">{{ item.descri }}</td>
                          <td style="white-space: nowrap">{{ item.direc1 }}</td>
                          <td style="white-space: nowrap">{{ item.direc2 }}</td>
                          <!-- <td style="white-space: nowrap;">{{ item.telefono }}</td> -->
                          <!-- <td>
                            <div style="text-align: center;" *ngIf="item.activo == true"> <i class="fas fa-check fa-lg"
                                style="color: green;"></i></div>
                          </td> -->
                          <td>
                            <div style="text-align: center" *ngIf="item.swacti == 'S'">
                              <i class="fas fa-check fa-lg" style="color: green"></i>
                            </div>
                            <div style="text-align: center" *ngIf="item.swacti != 'S'">
                              <i class="fas fa-times fa-lg" style="color: red"></i>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-template>
              </ngb-tab>
              <ngb-tab *ngIf="mostrar">
                <ng-template ngbTabTitle><b>Bancos</b></ng-template>
                <ng-template ngbTabContent>
                  <button type="button" class="btn btn-rounded btn-success" style="margin-top: 20px"
                    (click)="NuevoModal(content11)">
                    <i class="fa fa-plus"></i> Nuevo
                  </button>

                  <div class="table-responsive">
                    <table class="table table-sm table-striped table-bordered table-hover" style="margin-top: 30px">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Entidad Financiera</th>
                          <th>Tipo Cuenta EEFF</th>
                          <th>Moneda</th>
                          <th>Cuenta</th>
                          <!-- <th class="text-center">Activo</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of bancos">
                          <td scope="row" style="
                              display: table-cell;
                              text-align: center;
                              padding-bottom: 0px;
                            ">
                            <div class="btn-group btn-group-xs" role="group" style="margin: 0px; padding: 0px">
                              <button type="button" class="btn btn-sm" style="border: none; outline: none;"
                                (click)="AbrirModificarBanco(content12, item)">
                                <span class="fas fa-pencil-alt" aria-hidden="true"></span>
                              </button>
                              <button type="button" class="btn btn-sm" style="border: none; outline: none;"
                                (click)="EliminarBanco(item)">
                                <span class="fas fa-trash-alt" aria-hidden="true"></span>
                              </button>
                            </div>
                          </td>
                          <td style="white-space: nowrap">{{ item.desban }}</td>
                          <td style="white-space: nowrap">{{ item.descta }}</td>
                          <td style="white-space: nowrap">{{ item.tipmon }}</td>
                          <td style="white-space: nowrap">{{ item.cuenta }}</td>
                          <!-- <td>
                            <div style="text-align: center;" *ngIf="item.activo == true"> <i class="fas fa-check fa-lg"
                                style="color: green;"></i></div>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-template>
              </ngb-tab>
              <ngb-tab *ngIf="mostrar">
                <ng-template ngbTabTitle> <span>Adjuntos</span></ng-template>
                <ng-template ngbTabContent>

                  <div class="col-md-12">
                    <!-- <button tabindex="15" class="btn btn-rounded btn-info mr-3" type="button" id="loadFileXml" value="loadXml"
                      onclick="document.getElementById('file').click();"><i class="fas fa-upload"
                          style="margin-right: .3rem"></i> Importar documento</button> -->
                    <button tabindex="15" class="btn btn-rounded btn-info mr-3" type="button" id="loadFile"
                      style="margin-top: 20px" value="load" onclick="document.getElementById('file2').click();">
                      <i class="fas fa-upload" style="margin-right: 0.3rem"></i>
                      Importar archivo
                    </button>
                    <input type="file" style="display: none" id="file2" name="file2" accept=".jpg,.pdf,.xml,.xlsx,.xlsm"
                      multiple (change)="handleFileInput($event.target.files)" (click)="onInputClick($event)" />

                    <!-- <input  #fileUpload type="file" id="file" accept=".jpg,.pdf"
                                          (change)="uploadImage($event)">


                          <button [disabled]="boolguardar" class="btn btn-rounded btn-info m-b-15" (click)="agregarImagen()"
                          style="width: 115px; margin-right: 50px; margin-top: 10px;"
                          tabindex="14"><i
                              class="fa fa-save"></i>&nbsp; Guardar</button> -->
                    <br />
                    <br />

                    <!-- <input type="text" placeholder="Buscar ..." class="form-control col-md-6" (keydown)="onChange($event.target.value)" [(ngModel)]="csearchTerm" name="csearchTerm"> -->
                    <div class="table-responsive" style="height: 55vh">
                      <table class="table table-sm table-striped table-bordered table-hover" style="margin-top: 10px">
                        <thead>
                          <tr>
                            <th class="text-center"></th>
                            <th>Item</th>
                            <th>Formato</th>
                            <th>Nombre</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="cursor" *ngFor="let lst of doc_adjuntos">
                            <td style="text-align: center">
                              <div class="btn-group dropright" ngbDropdown container="body" role="group"
                                aria-label="Button group with nested dropdown" style="margin: 0px; padding: 0px">
                                <button class="btn btn-sm" ngbDropdownToggle style="margin: 0px; padding: 0px">
                                  <i class="fas fa-align-left"></i>
                                </button>
                                <ul class="dropdown-menu" ngbDropdownMenu>
                                  <li>
                                    <a class="dropdown-item" href="javascript:;" style="width: 84%"
                                      (click)="eliminarAdj(lst)">
                                      <i style="width: 84%" class="fas fa-trash-alt"
                                        style="margin-right: 0.3rem"></i>Eliminar</a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" href="javascript:;" style="width: 84%"
                                      (click)="descargarAdj(lst)">
                                      <i style="width: 84%" class="fas fa-download"
                                        style="margin-right: 0.3rem"></i>Descargar</a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                            <td style="white-space: nowrap;" class="text-left">{{lst.id}}
                            </td>
                            <td style="white-space: nowrap;" class="text-left">
                                {{lst.formato}}
                            </td>
                            <td style="white-space: nowrap;" class="text-left">
                                {{lst.nombre}}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </ng-template>
              </ngb-tab>
              <!--
            <ngb-tab *ngIf=mostrar>
              <ng-template ngbTabTitle><b>Archivos adjuntos</b></ng-template>
              <ng-template ngbTabContent>
              </ng-template>
            </ngb-tab>
            <ngb-tab *ngIf=mostrar>
              <ng-template ngbTabTitle><b>Clases de articulos</b></ng-template>
              <ng-template ngbTabContent>
              </ng-template>
            </ngb-tab>
            <ngb-tab *ngIf=mostrar>
              <ng-template ngbTabTitle><b>Detalle de proveedores</b></ng-template>
              <ng-template ngbTabContent>
              </ng-template>
            </ngb-tab> -->
            </ngb-tabset>
            <!-- Nueva Clase-->
            <ng-template #content1 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Nueva clase</h4>
                <button tabindex="101" type="button" class="close" aria-label="Close"
                  (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body pl-4">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                          <!---->
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Clase:</label>
                          <div class="col-md-2">
                            <input style="text-align: center" class="form-control tsiInput" [(ngModel)]="codClase"
                              name="codClase" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3" disabled />
                          </div>
                          <div class="col-md-7">
                            <select tabindex="102" class="focus-input input_border  tsiSelect select_border col-sm-12"
                              [(ngModel)]="codClase" (change)="onChangeClases($event.target.value)" name="codClase"
                              #selectClase>
                              <option *ngFor="let claseSele of listaclases" value="{{ claseSele.codigo }}">
                                {{
                                claseSele.codigo + " - " + claseSele.descri
                                }}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                          <!---->
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:</label>
                          <div class="col-md-2">
                            <input style="text-align: center" class="form-control tsiInput" [(ngModel)]="codCodigoClase"
                              name="codCodigoClase" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3" />
                          </div>
                          <div class="col-md-7">
                            <select [disabled]="disabledCodigosClaseCombo" tabindex="103"
                              class="focus-input input_border  tsiSelect select_border col-sm-12"
                              [(ngModel)]="codCodigoClase" name="codCodigoClase" #selectClase>
                              <option *ngFor="let codigoSele of listacodigos" value="{{ codigoSele.codigo }}">
                                {{
                                codigoSele.codigo + " - " + codigoSele.descri
                                }}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarClase()" tabindex="104"
                  #btnGuardar>
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                  (click)="modal.close('Save click')" tabindex="105">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
            <!-- Modifica Clase-->
            <ng-template #content2 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Modificar clase
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body pl-4">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                          <!---->
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Clase:</label>
                          <div class="col-md-2">
                            <input style="text-align: center" class="form-control tsiInput" [(ngModel)]="editinputcla"
                              name="editinputcla" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3" disabled />
                          </div>
                          <div class="col-md-7">
                            <select disabled tabindex="15"
                              class="focus-input input_border  tsiSelect select_border col-sm-12"
                              [(ngModel)]="editinputcla" name="editinputcla" #selectClase style="color: black">
                              <option *ngFor="let claseSele of listaclases" value="{{ claseSele.codigo }}">
                                {{
                                claseSele.codigo + " - " + claseSele.descri
                                }}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                          <!---->
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:</label>
                          <div class="col-md-2">
                            <input disabled style="text-align: center" class="form-control tsiInput"
                              [(ngModel)]="editinputcodigo" name="editinputcodigo" type="text"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3" />
                          </div>
                          <div class="col-md-7">
                            <select tabindex="15" class="focus-input input_border  tsiSelect select_border col-sm-12"
                              [(ngModel)]="editinputcodigo" name="editinputcodigo" #selectClase>
                              <option *ngFor="let codigoSele of listacodigos" value="{{ codigoSele.codigo }}">
                                {{
                                codigoSele.codigo + " - " + codigoSele.descri
                                }}
                              </option>
                            </select>
                          </div>
                          <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success" (click)="guardarActualizarClase()"
                  tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning" (click)="closeInsert()"
                  (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
            <!-- Nuevo Contacto-->

            <!-- Nueva Especificación-->
            <ng-template #content7 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Nueva Especificación:
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <div *ngIf="tipoConfirmar == 'Insert'" class="modal-body" id="first">
                          <h5 class="modal-title pull-left">
                            Visualización de especificaciones
                          </h5>
                          <div class="form-row col-md-12">
                            <table class="table table-striped display nowrap dataTable no-footer"
                              id="datatableEspecificaciones" cellspacing="0" width="100%">
                              <thead>
                                <tr>
                                  <th class="text-left">Código</th>
                                  <th class="text-left">Especificación</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let lst of especificacion" (click)="onCLickEspecificacion(lst)">
                                  <td class="text-left">{{ lst.codigo }}</td>
                                  <td class="text-left">{{ lst.descri }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div *ngIf="tipoConfirmar == 'InsertEspecificacion'" class="modal-body" id="first">
                          <form action="" #form="ngForm" autocomplete="off">
                            <div *ngIf="disabledDecimal == true" class="input-group">
                              <label style="margin-right: 0.6em">Decimal</label>
                              <input class="col-md-3 focus-input input_border form-control form-control-sm m-r-5"
                                id="decimal" name="decimal" [(ngModel)]="decimal" type="number" maxlength="5"
                                style="margin-right: 0.5rem"
                                onkeypress="return event.charCode >= 8 && event.charCode <= 57" />
                            </div>

                            <div *ngIf="disabledTexto == true" class="input-group">
                              <label style="margin-right: 1.8rem">Texto</label>
                              <input class="focus-input input_border form-control form-control-sm" id="texto"
                                name="texto" [(ngModel)]="texto" type="text" />
                            </div>

                            <div *ngIf="disabledCaracter == true" class="input-group">
                              <label style="margin-right: 0.5rem">Caracter</label>
                              <input class="focus-input input_border form-control form-control-sm col-md-2"
                                id="caracter" name="caracter" [(ngModel)]="caracter" type="text" />
                            </div>

                            <div *ngIf="disabledFecha == true" class="input-group">
                              <label style="margin-right: 1.75rem">Fecha</label>
                              <input class="focus-input input_border form-control form-control-sm col-md-4" id="fecha"
                                name="fecha" [(ngModel)]="fecha" type="date" max="2999-01-01" />
                            </div>

                            <div *ngIf="disabledTiempo == true" class="input-group">
                              <label style="margin-right: 1rem">Tiempo</label>
                              <input class="focus-input input_border form-control form-control-sm col-md-2" id="tiempo"
                                name="tiempo" [(ngModel)]="tiempo" type="time" />
                            </div>

                            <div *ngIf="disabledNumero == true" class="input-group">
                              <label style="margin-right: 0.7rem">Número</label>
                              <input class="focus-input input_border form-control form-control-sm col-md-2" id="numero"
                                name="numero" [(ngModel)]="numero" type="text" />
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="guardarEspecificacion()"
                  tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                  (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
            <!-- Modificar Especificación -->
            <ng-template #content8 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Modificar Especificación:
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-12">
                        <h5 class="modal-title pull-left"></h5>
                        <div class="form-row col-md-12">
                          <table class="table table-striped display nowrap dataTable no-footer"
                            id="datatableEspecificaciones" cellspacing="0" width="100%">
                            <thead>
                              <tr></tr>
                            </thead>
                            <tbody>
                              <div>
                                <h5 class="modal-title pull-left">
                                  {{ desEspecificacionUpd }}
                                </h5>
                                <br />
                              </div>
                              <div>
                                <form action="" #form="ngForm" autocomplete="off">
                                  <div *ngIf="disabledDecimalUpd == true" class="input-group">
                                    <label style="margin-right: 0.6em">Decimal</label>
                                    <input class="col-md-3 focus-input input_border form-control form-control-sm m-r-5"
                                      id="decimalUpd" name="decimalUpd" [(ngModel)]="decimalUpd" maxlength="5"
                                      type="text" style="margin-right: 0.5rem"
                                      onkeypress="return event.charCode >= 8 && event.charCode <= 57" />
                                  </div>

                                  <div *ngIf="disabledTextoUpd == true" class="input-group">
                                    <label style="margin-right: 1.8rem">Texto</label>
                                    <input class="focus-input input_border form-control form-control-sm" id="textoUpd"
                                      name="textoUpd" [(ngModel)]="textoUpd" type="text" />
                                  </div>

                                  <div *ngIf="disabledCaracterUpd == true" class="input-group">
                                    <label style="margin-right: 0.5rem">Caracter</label>
                                    <input class="focus-input input_border form-control form-control-sm col-md-2"
                                      id="caracterUpd" name="caracterUpd" [(ngModel)]="caracterUpd" type="text" />
                                  </div>

                                  <div *ngIf="disabledFechaUpd == true" class="input-group">
                                    <label style="margin-right: 1.75rem">Fecha</label>
                                    <input class="focus-input input_border form-control form-control-sm col-md-4"
                                      id="fechaUpd" name="fechaUpd" [(ngModel)]="fechaUpd" type="date"
                                      max="2999-01-01" />
                                  </div>

                                  <div *ngIf="disabledTiempoUpd == true" class="input-group">
                                    <label style="margin-right: 1rem">Tiempo</label>
                                    <input class="focus-input input_border form-control form-control-sm col-md-2"
                                      id="tiempoUpd" name="tiempoUpd" [(ngModel)]="tiempoUpd" type="time" />
                                  </div>

                                  <div *ngIf="disabledNumeroUpd == true" class="input-group">
                                    <label style="margin-right: 0.7rem">Número</label>
                                    <input class="focus-input input_border form-control form-control-sm col-md-2"
                                      id="numeroUpd" name="numeroUpd" [(ngModel)]="numeroUpd" type="text" />
                                  </div>
                                </form>
                              </div>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="ModificarEspecificacion()"
                  tabindex="5">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                  (click)="modal.close('Save click')" tabindex="6">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
            <!-- Nueva Direccion de Envío-->
            <ng-template #content9 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Nueva dirección de envío
                </h4>
                <button tabindex="701" type="button" class="close" aria-label="Close"
                  (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body px-4 ">
                <form action="" #form="ngForm" autocomplete="off">
                  <!--<div class="input-group" style="margin-bottom: 0.5rem;">
                <label style="margin-right: 2.6rem">Código</label>
                  <input class="col-md-1 focus-input input_border form-control  form-control-sm m-r-5" id="codEnvio" name="codEnvio"
                    [(ngModel)]="codEnvio" type="text" style="margin-right: .5rem" disabled>



                  <div style="margin-left: 15px;">
                    <label class="ui-checkbox">
                      <input type="checkbox" id="activoDirecEnvio" [checked]="activoDirecEnvio"
                        (change)="onChangeactivoDirecEnvio($event.target.checked)" tabindex="604">
                      <span class="input-span"></span>
                    </label> <label class="tsiLabel form-check-label" for="activoDirecEnvio">Activo</label>
                  </div>


                </div>-->

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Descripción:</label>
                    <input class="focus-input input_border form-control col-md-8 tsiInput" id="desEnvio" name="desEnvio"
                      [(ngModel)]="desEnvio" maxlength="50" type="text" tabindex="801" />
                    <span style="color: red; font: sans-serif; margin-left: -6px">(*)</span>

                    <app-custom-switch [(valor)]="activoDirecEnvio" [identificador]="'1'"
                      style="margin-left: -14px;"></app-custom-switch>

                  </div>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Dirección:</label>
                    <input class="focus-input input_border form-control col-md-8 tsiInput" id="direccionE1"
                      name="direccionE1" [(ngModel)]="direccionE1" maxlength="120" type="text" tabindex="803" />
                    <span style="color: red; font: sans-serif; margin-left: -6px">(*)</span>
                  </div>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Referencia:</label>
                    <input class="focus-input input_border form-control col-md-4 tsiInput" id="referenciaEnvio"
                      name="referenciaEnvio" [(ngModel)]="referenciaEnvio" maxlength="50" type="text" tabindex="804" />

                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Teléfono:</label>
                    <input class="focus-input input_border form-control col-md-3 tsiInput" id="telefonoEnvio"
                      name="telefonoEnvio" [(ngModel)]="telefonoEnvio" maxlength="30" type="text" tabindex="805" />
                  </div>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código EAN:</label>
                    <input class="focus-input input_border form-control col-md-4 tsiInput" id="codEanEnvio"
                      name="codEanEnvio" [(ngModel)]="codEanEnvio" maxlength="30" type="text" tabindex="806" />

                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Celular:</label>
                    <input class="focus-input input_border form-control col-md-3 tsiInput" id="celularEnvio"
                      name="celularEnvio" [(ngModel)]="celularEnvio" maxlength="30" type="text" tabindex="807" />
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="nuevaDireccionEnvio()"
                  tabindex="808">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                  (click)="modal.close('Save click')" tabindex="809">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
            <!-- Modificar Direccion de Envío -->
            <ng-template #content10 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Modificar dirección de envío
                </h4>
                <button tabindex="901" type="button" class="close" aria-label="Close"
                  (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body px-4 ">
                <form action="" #form="ngForm" autocomplete="off">
                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:</label>
                    <input class="focus-input input_border form-control col-md-1 tsiInput" id="codEnvioUpd"
                      name="codEnvioUpd" [(ngModel)]="codEnvioUpd" type="text" style="margin-right: 0.5rem" disabled />

                    <app-custom-switch [(valor)]="activoDirecEnvio" [identificador]="'2'"
                      style="margin-left: -14px;"></app-custom-switch>

                  </div>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Descripción:</label>
                    <input class="focus-input input_border form-control col-md-8 tsiInput" id="desEnvioUpd"
                      name="desEnvioUpd" [(ngModel)]="desEnvioUpd" maxlength="50" type="text" tabindex="903" />
                  </div>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Dirección:</label>
                    <input class="focus-input input_border form-control col-md-8 tsiInput" id="direccionE1Upd"
                      name="direccionE1Upd" [(ngModel)]="direccionE1Upd" maxlength="120" type="text" tabindex="904" />
                  </div>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Referencia:</label>
                    <input class="focus-input input_border form-control col-md-4 tsiInput" id="referenciaEnvioUpd"
                      name="referenciaEnvioUpd" [(ngModel)]="referenciaEnvioUpd" maxlength="50" type="text"
                      tabindex="905" />

                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Teléfono:</label>
                    <input class="focus-input input_border form-control col-md-3 tsiInput" id="telefonoEnvioUpd"
                      name="telefonoEnvioUpd" [(ngModel)]="telefonoEnvioUpd" maxlength="30" type="text"
                      tabindex="906" />
                  </div>

                  <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código EAN:</label>
                    <input class="focus-input input_border form-control col-md-4 tsiInput" id="codEanEnvioUpd"
                      name="codEanEnvioUpd" [(ngModel)]="codEanEnvioUpd" maxlength="30" type="text" tabindex="907" />

                    <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Celular:</label>
                    <input class="focus-input input_border form-control col-md-3 tsiInput" id="celularEnvioUpd"
                      name="celularEnvioUpd" [(ngModel)]="celularEnvioUpd" maxlength="30" type="text" tabindex="908" />
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="ModificarDireccionEnvio()"
                  tabindex="909">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                  (click)="modal.close('Save click')" tabindex="910">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
            <!--Nuevo Banco-->
            <ng-template #content11 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">Nuevo banco</h4>
                <button tabindex="1000" type="button" class="close" aria-label="Close"
                  (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body px-4">
                <form action="" #form="ngForm" autocomplete="off">
                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label for="fname2" class="col-md-4 label-size tsiLabel mt-2">Financiera:</label>
                        <input class="col-md-2 focus-input input_border form-control tsiInput" id="codBanco"
                          name="codBanco" [(ngModel)]="codBanco" type="number"
                          style="margin-right: 0.5rem; margin-left: -45px;" maxlength="3" tabindex="1001" />

                        <select class="focus-input input_border  tsiSelect select_border col-md-7" id="cboBanco"
                          name="codBanco" [(ngModel)]="codBanco" (change)="onChangeFinanciera($event.target.value)"
                          tabindex="1002">
                          <option *ngFor="let cc of financieras" value="{{ cc.codigo }}">
                            {{ cc.codigo }} - {{ cc.descri }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label or="fname2" class="col-md-4 label-size tsiLabel mt-2">Tipo cuenta:</label>
                        <input class="col-md-2 focus-input input_border form-control tsiInput" id="codTipoCuenta"
                          name="codTipoCuenta" [(ngModel)]="codTipoCuenta" type="text"
                          style="margin-right: 0.5rem; margin-left: -33px;" maxlength="2" tabindex="1003" />

                        <select class="focus-input input_border  tsiSelect select_border col-md-7" id="cboTipoCuenta"
                          name="codTipoCuenta" [(ngModel)]="codTipoCuenta" (change)="onChangeTipoCuenta()"
                          [disabled]="disabledTipoCuenta" tabindex="1004">
                          <option *ngFor="let ccc of tipocuentas" value="{{ ccc.codigo }}">
                            {{ ccc.descri }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label or="fname2" class="col-md-4 label-size tsiLabel mt-2">Moneda:</label>
                        <input class="col-md-2 focus-input input_border form-control tsiInput" id="codMoneda"
                          name="codMoneda" [(ngModel)]="codMoneda" type="text" tabindex="1005"
                          style="margin-right: 0.5rem; margin-left: -45px;" maxlength="3" />
                        <select class="focus-input input_border  tsiSelect select_border col-md-7" id="cboMoneda"
                          name="codMoneda" tabindex="1006" [(ngModel)]="codMoneda" [disabled]="disabledMoneda">
                          <option *ngFor="let mon of monedas" value="{{ mon.codmon }}">
                            {{ mon.desmon }}
                          </option>
                        </select>
                      </div>

                    </div>
                    <div class="col-md-5">
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label or="fname2" class="col-md-5 label-size tsiLabel mt-2">N° cuenta:</label>
                        <input class="col-md-11 focus-input input_border form-control tsiInput " id="desCuenta"
                          name="desCuenta" tabindex="1007" [(ngModel)]="desCuenta" type="text"
                          style=" margin-left: -40px;" maxlength="100" />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" [disabled]="disabledBotonBanco || desCuenta.length == 0"
                  class="btn btn-rounded btn-success m-b-15" (click)="guardarBanco()" tabindex="1008">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsertBanco()"
                  (click)="modal.close('Save click')" tabindex="1009">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
            <!--Modificar Banco-->
            <ng-template #content12 let-modal>
              <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title">
                  Modificar Banco
                </h4>
                <button tabindex="1100" type="button" class="close" aria-label="Close"
                  (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body px-4">
                <form action="" #form="ngForm" autocomplete="off">
                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label for="fname2" class="col-md-4 label-size tsiLabel mt-2">Financiera:</label>
                        <input class="col-md-2 focus-input input_border form-control tsiInput" id="codBancoUpd"
                          name="codBancoUpd" [(ngModel)]="codBancoUpd" type="number"
                          style="margin-right: 0.5rem; margin-left: -45px;" maxlength="3" tabindex="1001" />

                        <select disabled class="focus-input input_border  tsiSelect select_border col-md-7"
                          id="cboBanco" name="codBancoUpd" [(ngModel)]="codBancoUpd"
                          (change)="onChangeFinanciera($event.target.value)">
                          <option *ngFor="let cc of financieras" value="{{ cc.codigo }}">
                            {{ cc.descri }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label for="fname2" class="col-md-4 label-size tsiLabel mt-2">Tipo cuenta:</label>
                        <input class="col-md-2 focus-input input_border form-control tsiInput" id="codTipoCuentaUpd"
                          name="codTipoCuentaUpd" [(ngModel)]="codTipoCuentaUpd" type="text"
                          style="margin-right: 0.5rem; margin-left: -33px;" maxlength="2" />

                        <select class="focus-input input_border  tsiSelect select_border col-md-7" id="cboTipoCuentaUpd"
                          name="codTipoCuentaUpd" [(ngModel)]="codTipoCuentaUpd" (change)="onChangeTipoCuenta()"
                          disabled>
                          <option *ngFor="let ccc of tipocuentas" value="{{ ccc.codigo }}">
                            {{ ccc.descri }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="col-md-6">
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label for="fname2" class="col-md-4 label-size tsiLabel mt-2">Moneda:</label>
                        <input class="col-md-2 focus-input input_border form-control tsiInput"
                          style="margin-right: 0.5rem; margin-left: -45px;" id="codMonedaUpd" name="codMonedaUpd"
                          [(ngModel)]="codMonedaUpd" type="text" maxlength="3" />
                        <select class="focus-input input_border  tsiSelect select_border col-md-7" id="cboMoneda"
                          name="codMonedaUpd" [(ngModel)]="codMonedaUpd" disabled>
                          <option *ngFor="let mon of monedas" value="{{ mon.codmon }}">
                            {{ mon.desmon }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                        <label for="fname2" class="col-md-5 label-size tsiLabel mt-2">N° cuenta:</label>
                        <input class="col-md-11 focus-input input_border form-control  tsiInput " id="desCuentaUpd"
                          name="desCuentaUpd" tabindex="1102" [(ngModel)]="desCuentaUpd" type="text"
                          style=" margin-left: -40px;" maxlength="100" />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-rounded btn-success m-b-15" (click)="modificarBanco()"
                  tabindex="1103">
                  <i class="fas fa-angle-double-right"></i> Continuar
                </button>
                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                  (click)="modal.close('Save click')" tabindex="1104">
                  <i class="fa fa-times-circle"></i> Cancelar
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>